import { useParams } from "react-router-dom";

import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";
import { variants } from "Login/TwoFA/constants";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

const usePrefectTwoFA = () => {
  const { fundID } = useParams();
  const {
    state: { tabID },
  } = usePaymentPage();

  usePostTwoFactorAuth({
    postData: !window.data.loginLevel
      ? { tabID, fundID: Number(fundID) }
      : false,
    // leveraging variant to make hook inactive if we are not going to need to log in
    variant: variants.give,
  });
};

export default usePrefectTwoFA;
